/* Optional FDP product tabs. Legacy sections neither load nor initialize this asset. */
(function (window, document) {
  'use strict';

  if (window.FDPProductTabs) {
    window.FDPProductTabs.initAll(document);
    return;
  }

  var REQUEST_TIMEOUT_MS = 15000;
  var TAB_SELECTOR = '[data-fdp-lazy-tab]';
  var LINK_SELECTOR = '[data-fdp-tab-link]';
  var api = {};
  window.FDPProductTabs = api;

  function listen(state, target, name, handler, options) {
    target.addEventListener(name, handler, options);
    state.cleanup.push(function () { target.removeEventListener(name, handler, options); });
  }

  function setState(tab, value) {
    tab.el.dataset.tabState = value;
    tab.el.setAttribute('aria-busy', value === 'loading' ? 'true' : 'false');
    var status = tab.el.querySelector('[data-fdp-tab-status]');
    var message = tab.el.querySelector('[data-fdp-tab-message]');
    var retry = tab.el.querySelector('[data-fdp-tab-retry]');
    var fallback = tab.el.querySelector('[data-fdp-tab-fallback]');
    status.hidden = value === 'idle' || value === 'loaded';
    retry.hidden = value !== 'error';
    fallback.hidden = value !== 'error' && value !== 'empty';
    message.textContent = value === 'loading' ? (window.button_load_more || {}).loading || 'Loading...'
      : value === 'error' ? 'Unable to load these products. Please try again.'
      : value === 'empty' ? (window.button_load_more || {}).no_more || 'No products to display.' : '';
  }

  function isActive(tab) {
    return tab.wrapper.classList.contains('active');
  }

  function initSwiper(tab) {
    if (!isActive(tab) || tab.el.dataset.tabState !== 'loaded' || typeof window.Swiper === 'undefined') return;
    if (tab.el.swiper && !tab.el.swiper.destroyed) {
      tab.el.swiper.update();
      return;
    }
    if (!tab.el.querySelector('.swiper-slide')) return;
    tab.swiper = new window.Swiper(tab.el, {
      slidesPerView: 'auto',
      speed: 600,
      loop: tab.el.querySelectorAll('.swiper-slide').length > 1,
      spaceBetween: 0,
      grabCursor: true,
      watchOverflow: true,
      navigation: {
        nextEl: tab.el.querySelector('.swiper-button-next'),
        prevEl: tab.el.querySelector('.swiper-button-prev')
      }
    });
  }

  function namespaceIds(container, scope) {
    Array.prototype.forEach.call(container.children, function (slide, index) {
      if (slide.dataset.fdpIdsReady) return;
      slide.dataset.fdpIdsReady = '1';
      var ids = {};
      Array.prototype.forEach.call(slide.querySelectorAll('[id]'), function (el) {
        var old = el.id;
        el.id = old + '-' + scope + '-' + index;
        ids[old] = el.id;
      });
      ['for', 'aria-controls', 'aria-labelledby', 'aria-describedby', 'data-form-id'].forEach(function (name) {
        Array.prototype.forEach.call(slide.querySelectorAll('[' + name + ']'), function (el) {
          var value = el.getAttribute(name).split(/\s+/).map(function (id) {
            var hash = id.charAt(0) === '#' ? '#' : '';
            var key = hash ? id.slice(1) : id;
            return ids[key] ? hash + ids[key] : id;
          }).join(' ');
          el.setAttribute(name, value);
        });
      });
    });
  }

  function readSavedItems(key) {
    try {
      var items = JSON.parse(window.localStorage.getItem(key) || '[]');
      return Array.isArray(items) ? items : [];
    } catch (error) { return []; }
  }

  function refreshCards(tab) {
    if (window.wishlist && window.wishlist.show) {
      var wishlist = readSavedItems('wishlistItem');
      Array.prototype.forEach.call(tab.el.querySelectorAll('[data-wishlist]'), function (el) {
        var saved = wishlist.indexOf(el.dataset.wishlistHandle) !== -1;
        el.classList.toggle('wishlist-added', saved);
        var text = el.querySelector('.text');
        if (text) text.textContent = saved ? window.wishlist.added : window.wishlist.add;
      });
    }
    if (window.compare && window.compare.show) {
      var compare = readSavedItems('compareItem');
      Array.prototype.forEach.call(tab.el.querySelectorAll('[data-product-compare-handle]'), function (el) {
        var saved = compare.indexOf(el.dataset.productCompareHandle) !== -1;
        var icon = el.querySelector('.compare-icon');
        var text = el.querySelector('.text');
        var input = el.querySelector('input');
        if (icon) icon.classList.toggle('is-checked', saved);
        if (text) text.textContent = saved ? window.compare.added : window.compare.add;
        if (input) input.checked = saved;
      });
    }
    // The theme's cart/quick-view/swatch actions are delegated. Only refresh
    // card state and optional display integrations here, not their global handlers.
    try {
      if (window.sharedFunctions && window.sharedFunctions.checkNeedToConvertCurrency &&
          window.sharedFunctions.checkNeedToConvertCurrency() && window.Currency && window.jQuery) {
        window.Currency.convertAll(window.shop_currency, window.jQuery('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
      }
      if (window.lazySizes && window.lazySizes.loader) window.lazySizes.loader.checkElems();
      if (window.review && window.review.show && window.SPR && typeof window.SPR.initDomEls === 'function') {
        window.SPR.initDomEls();
        window.SPR.loadBadges();
      }
    } catch (error) {
      // Optional app integrations must not turn a successfully loaded tab into an error.
      if (window.console) window.console.warn('FDP product tab enhancement failed.', error);
    }
  }

  function needsPlatmartSwatches(tab) {
    return isActive(tab) && tab.el.dataset.tabState === 'loaded' && tab.el.dataset.tabUrl &&
      Array.prototype.some.call(tab.el.querySelectorAll('.product-item'), function (card) {
        return !card.closest('[data-pl-swatches-ignore]') &&
          !card.querySelector('[data-pl-swatches-loaded], .pl-swatches-collection, .pl-collection-swatches');
      });
  }

  function refreshPlatmartSwatches(state) {
    if (state.destroyed || state.platmartTimer || !state.tabs.some(needsPlatmartSwatches)) return;
    var attempts = 0;
    function refresh() {
      state.platmartTimer = null;
      if (state.destroyed || !state.tabs.some(needsPlatmartSwatches)) return;
      var config = window.platmartSwatchesConfig;
      if (config && config.collectionWidgetEnabled === false) return;
      var widget = window.PlatmartSwatchesCollection;
      if (!widget || typeof widget.load !== 'function') {
        // App embeds may initialize after the section. Retry briefly, not forever.
        if (++attempts < 20) state.platmartTimer = window.setTimeout(refresh, 250);
        return;
      }
      try {
        // Hidden hover-prefetched cards can be missed by Platmart's auto-detection.
        // Refresh only AFTER activation; its observer does not watch class changes.
        // pl-collection-swatches-loaded is a completion event, NOT a reload trigger:
        // https://platmart.io/docs/color-swatches/developers/widget-events/
        widget.load();
        // Cached renders can be synchronous and do not always emit the event.
        state.tabs.forEach(function (tab) { if (isActive(tab)) initSwiper(tab); });
      } catch (error) {
        if (window.console) window.console.warn('FDP product tab swatch refresh failed.', error);
      }
    }
    // Coalesce click/MutationObserver/load callbacks and let the app's normal
    // 200ms DOM observer render first when it can. Never reload its script.
    state.platmartTimer = window.setTimeout(refresh, 250);
  }

  function parseResponse(html, tab) {
    var doc = new window.DOMParser().parseFromString(html, 'text/html');
    var responses = doc.querySelectorAll('template[data-fdp-product-tab-response]');
    if (responses.length !== 1) throw new Error('Invalid product tab response.');
    var response = responses[0];
    var limit = Number(tab.el.dataset.limit);
    var count = Number(response.dataset.count);
    if (!Number.isInteger(limit) || limit < 1 || limit > 20 ||
        response.dataset.collection !== tab.el.dataset.collection || Number(response.dataset.limit) !== limit ||
        !/^\d+$/.test(response.dataset.count || '') || !Number.isInteger(count) || count > limit) {
      throw new Error('Mismatched product tab response.');
    }
    var content = response.content;
    var slides = Array.prototype.slice.call(content.children);
    if (slides.length !== count || slides.some(function (slide) {
      return !slide.classList.contains('swiper-slide') || !slide.querySelector('.product-item');
    }) || Array.prototype.some.call(content.childNodes, function (node) {
      return node.nodeType === 3 && node.textContent.trim();
    })) throw new Error('Invalid product tab slides.');
    return content.cloneNode(true);
  }

  function loadTab(state, tab) {
    if (state.destroyed || tab.request || !tab.el.dataset.tabUrl ||
        ['idle', 'error'].indexOf(tab.el.dataset.tabState) === -1) return tab.request;
    setState(tab, 'loading');
    tab.controller = window.AbortController ? new window.AbortController() : null;
    var options = { credentials: 'same-origin' };
    if (tab.controller) options.signal = tab.controller.signal;
    var timeout = new Promise(function (resolve, reject) {
      tab.timer = window.setTimeout(function () {
        reject(new Error('Product tab request timed out.'));
        if (tab.controller) tab.controller.abort();
      }, REQUEST_TIMEOUT_MS);
    });
    var request = Promise.resolve().then(function () {
      return window.fetch(tab.el.dataset.tabUrl, options);
    }).then(function (response) {
      if (!response.ok) throw new Error('HTTP ' + response.status);
      return response.text();
    });
    tab.request = Promise.race([request, timeout]).then(function (html) {
      if (state.destroyed) return;
      var content = parseResponse(html, tab);
      namespaceIds(content, tab.el.dataset.cardScope);
      var wrapper = tab.el.querySelector('[data-fdp-tab-slides]');
      wrapper.replaceChildren(content);
      setState(tab, wrapper.children.length ? 'loaded' : 'empty');
      // Delegated actions already work; refresh display state after insertion.
      refreshCards(tab);
      initSwiper(tab);
      refreshPlatmartSwatches(state);
      document.dispatchEvent(new window.CustomEvent('fdp:product-tab:loaded', { detail: { container: tab.el } }));
    }).catch(function () {
      if (!state.destroyed) setState(tab, 'error');
    }).then(function () {
      window.clearTimeout(tab.timer);
      tab.controller = null;
      tab.request = null;
    });
    return tab.request;
  }

  function activate(state, tab) {
    if (tab.el.dataset.tabState === 'idle' || tab.el.dataset.tabState === 'error') loadTab(state, tab);
    else if (tab.el.dataset.tabState === 'loaded') {
      refreshCards(tab);
      initSwiper(tab);
      refreshPlatmartSwatches(state);
    }
  }

  function initialiseSection(section) {
    if (section._fdpProductTabs) return;
    var state = { section: section, tabs: [], byId: Object.create(null), cleanup: [], destroyed: false };
    var elements = section.querySelectorAll(TAB_SELECTOR);
    if (!elements.length) return;
    section._fdpProductTabs = state;
    state.links = section.querySelectorAll(LINK_SELECTOR);
    state.observer = new window.MutationObserver(function (records) {
      records.forEach(function (record) {
        if (!record.target.classList.contains('active')) return;
        state.tabs.forEach(function (tab) { if (tab.wrapper === record.target) activate(state, tab); });
      });
    });
    Array.prototype.forEach.call(elements, function (el) {
      var tab = { el: el, wrapper: el.closest('.product-block-wrapper2'), request: null, swiper: null };
      if (!tab.wrapper) return;
      state.tabs.push(tab);
      state.byId[el.dataset.fdpBlockId] = tab;
      state.observer.observe(tab.wrapper, { attributes: true, attributeFilter: ['class'] });
      if (el.dataset.tabState === 'loaded') namespaceIds(el.querySelector('[data-fdp-tab-slides]'), el.dataset.cardScope);
      setState(tab, el.dataset.tabState);
      listen(state, el.querySelector('[data-fdp-tab-retry]'), 'click', function () { loadTab(state, tab); });
      ['mouseover', 'mouseout'].forEach(function (name) {
        listen(state, el, name, function (event) {
          if (window.innerWidth <= 1200) return;
          var card = event.target.closest('.product-item .card');
          if (!card || (event.relatedTarget && card.contains(event.relatedTarget))) return;
          var video = card.querySelector('video');
          if (!video) return;
          if (name === 'mouseout') video.pause();
          else {
            var playing = video.play();
            if (playing && playing.catch) playing.catch(function () {});
          }
        });
      });
    });

    listen(state, document, 'pl-collection-swatches-loaded', function () {
      // Swatches arrive asynchronously and may change card dimensions. Do not
      // call widget.load() here: that would create a render/refresh feedback loop.
      state.tabs.forEach(function (tab) { if (isActive(tab)) initSwiper(tab); });
    });

    function prefetch(event) {
      var link = event.target.closest(LINK_SELECTOR);
      if (!link || !section.contains(link)) return;
      var tab = state.byId[link.dataset.fdpTabLink];
      if (tab && tab.el.dataset.tabState === 'idle') loadTab(state, tab);
    }
    ['pointerover', 'touchstart', 'focusin'].forEach(function (name) {
      listen(state, section, name, prefetch, { passive: true });
    });
    // Only enabled sections intercept their tab links. Disabled sections keep
    // the existing sg-functions.js handlers, markup and inline Swiper script.
    listen(state, section, 'click', function (event) {
      var link = event.target.closest(LINK_SELECTOR);
      if (!link || !section.contains(link)) return;
      var tab = state.byId[link.dataset.fdpTabLink];
      if (!tab) return;
      event.preventDefault();
      event.stopPropagation();
      var dropdown = link.closest('.product-block-collections-wrapper');
      var dropdownParent = dropdown && dropdown.parentElement;
      if (dropdown && link.classList.contains('active')) {
        dropdown.classList.toggle('collections-expanded');
        dropdownParent.classList.toggle('collections-expanded');
        activate(state, tab);
        return;
      }
      Array.prototype.forEach.call(state.links, function (other) { other.classList.toggle('active', other === link); });
      state.tabs.forEach(function (other) { other.wrapper.classList.toggle('active', other === tab); });
      if (dropdown) {
        dropdown.classList.remove('collections-expanded');
        dropdownParent.classList.remove('collections-expanded');
        dropdown.scrollTop = 0;
        var toggle = dropdown.querySelector('.pbc-toggle-button');
        if (toggle) toggle.style.display = 'none';
      }
      activate(state, tab);
    }, true);

    function ready() { state.tabs.forEach(function (tab) { if (isActive(tab)) activate(state, tab); }); }
    ready();
    if (document.readyState === 'loading') listen(state, document, 'DOMContentLoaded', ready);
    listen(state, window, 'load', ready);
  }

  function sectionsWithin(scope) {
    var sections = [];
    if (scope.matches && scope.matches('.product-block') && scope.querySelector(TAB_SELECTOR)) sections.push(scope);
    Array.prototype.forEach.call(scope.querySelectorAll(TAB_SELECTOR), function (el) {
      var section = el.closest('.product-block');
      if (section && sections.indexOf(section) === -1) sections.push(section);
    });
    return sections;
  }

  api.initAll = function (scope) { sectionsWithin(scope || document).forEach(initialiseSection); };
  api.destroyAll = function (scope) {
    sectionsWithin(scope || document).forEach(function (section) {
      var state = section._fdpProductTabs;
      if (!state) return;
      state.destroyed = true;
      state.observer.disconnect();
      window.clearTimeout(state.platmartTimer);
      state.cleanup.forEach(function (cleanup) { cleanup(); });
      state.tabs.forEach(function (tab) {
        window.clearTimeout(tab.timer);
        if (tab.controller) tab.controller.abort();
        if (tab.el.dataset.tabState === 'loading') setState(tab, 'idle');
        if (tab.swiper && !tab.swiper.destroyed) tab.swiper.destroy(true, true);
      });
      delete section._fdpProductTabs;
    });
  };
  api.initAll(document);
  document.addEventListener('shopify:section:load', function (event) { api.initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { api.destroyAll(event.target); });
})(window, document);